import { Container } from 'unstated'
// API: https://github.com/kolodny/immutability-helper | https://reactjs.org/docs/update.html
import update from 'immutability-helper'

class ShopsBuyerState extends Container {
  state = {
    orderHistory: {
      // contains objects for orders from shop1, shop2 and so on
      // also order status?
    },
    catalogListing: {},
    lists: {
      // manage favorites and other lists
      // 'favorites': [{ product1/shop1 }, { product2/shop2 }]
    },
    cart: {
      orangeMoon: [
        {
          productId: '1',
          photoUrl:
            'https://uideploy--staticcontent--4d0fbe1fedb5c--ghe.preview.dev.paypalinc.com/ppme_shops/samples/earring-1.png',
          productTitle: 'Copper & Turquoise Teardrop Earrings',
          productPrice: 21.0,
          quantity: 1,
          availableItems: 12,
          shippingFee: 6.5,
          currencyCode: 'USD',
        },
      ],
    },
  }

  addItemtoCart = (shopHandle, product) => {
    // If product already exists in cart, only increase count in that case
    if (shopHandle in this.state.cart) {
      const productIndex = this.state.cart[shopHandle].findIndex(
        item => item.productId === product[0].productId,
      )
      if (this.state.cart[shopHandle][productIndex]) {
        const newState = update(this.state, {
          cart: {
            [shopHandle]: {
              [productIndex]: {
                quantity: {
                  $apply: function (totalQuantity) {
                    totalQuantity = totalQuantity + 1
                    return totalQuantity
                  },
                },
              },
            },
          },
        })
        this.setState(newState)
      } else {
        // If user already has some products but in cart for this shop handle but this product doesn't exist
        const newState = update(this.state, {
          cart: {
            [shopHandle]: {
              $push: [product],
            },
          },
        })
        this.setState(newState)
      }
    } else {
      // If cart is empty for this shop handle
      const newState = update(this.state, {
        cart: {
          [shopHandle]: {
            $set: [product],
          },
        },
      })
      this.setState(newState)
    }
  }

  deleteItemFromCart = (shopHandle, productId) => {
    if (shopHandle in this.state.cart) {
      const productIndex = this.state.cart[shopHandle].findIndex(
        item => item.productId === productId,
      )

      // Remove the item from shop
      const newState = update(this.state, {
        cart: {
          [shopHandle]: {
            $splice: [[productIndex, 1]],
          },
        },
      })

      // If there are no items in the cart for this shop, remove the shop from the cart
      const updatedCart = {}
      for (let key in newState.cart) {
        if (newState.cart[key].length !== 0) {
          updatedCart[key] = newState.cart[key]
        }
      }

      const updatedState = {
        ...newState,
        cart: updatedCart,
      }
      this.setState(updatedState)
    }
  }

  decrementQuantityFromCart = (shopHandle, productId) => {
    if (shopHandle in this.state.cart) {
      const productIndex = this.state.cart[shopHandle].findIndex(
        item => item.productId === productId,
      )

      // Reduce the quantity of the item by one if the quantity count is greater than one
      const newState = update(this.state, {
        cart: {
          [shopHandle]: {
            [productIndex]: {
              quantity: {
                $apply: function (totalQuantity) {
                  totalQuantity = totalQuantity - 1
                  return totalQuantity
                },
              },
            },
          },
        },
      })

      if (this.state.cart[shopHandle][productIndex].quantity === 0) {
        // If only one item is in the cart and the quantity is decrement (quantity for this item is 0), remove this item from the cart
        this.deleteItemFromCart(shopHandle, productId)
      }
      this.setState(newState)
    }
  }

  getCartCountForShop = shopHandle => {
    if (shopHandle in this.state.cart) {
      return this.state.cart[shopHandle].reduce(
        (sum, item) => sum + parseInt(item.quantity),
        0,
      )
    }
    return 0
  }

  getTotalCartCount = () => {
    let total = 0
    for (const shopHandle in this.state.cart) {
      total += this.getCartCountForShop(shopHandle)
    }
    return total
  }
}

export default ShopsBuyerState
